import React from 'react';

import keyBy from 'lodash/keyBy';

import { useQueries, useQueryClient } from '@lumapps/base-api/react-query';

import { getQueryMetadata } from '../api';
import type { Metadata, QueryMetadataOptions } from '../types';

/**
 * Get metadata by ids
 * Uses react-query cache and API batching. if the metadata provided are already valid, then nothing is fetched
 */
export const useQueryMetadataByIds = (
    metadataIds: Array<string | Partial<Metadata> | undefined>,
    options: QueryMetadataOptions = {},
) => {
    const queryClient = useQueryClient();
    const queries = useQueries({
        queries: metadataIds.map((metadata) => getQueryMetadata(queryClient, metadata, options)),
    });
    const metadataById = React.useMemo(() => {
        return queries.items ? keyBy(queries.items, 'id') : undefined;
    }, [queries.items]);
    return { ...queries, metadataById };
};
